import { styled } from "@mui/material/styles";
import { Card, Box } from "@mui/material";

export const StyledCard = styled(Card)(({ theme }) => ({
  display: "flex",
  flexDirection: "column",
  height: "100%",
  transition: "box-shadow 0.2s ease-in-out",
  "&:hover": {
    boxShadow: theme.shadows[6],
  },
  position: "relative",
}));

export const LoadingOverlay = styled(Box)(({ theme }) => ({
  position: "absolute",
  top: 0,
  left: 0,
  right: 0,
  bottom: 0,
  backgroundColor: "rgba(255, 255, 255, 0.8)",
  display: "flex",
  flexDirection: "column",
  justifyContent: "center",
  alignItems: "center",
  zIndex: 10,
  borderRadius: theme.shape.borderRadius,
}));

export const MapContainerStyle = {
  width: "100%",
  height: "600px",
};

export const londonCenter = {
  lat: 51.5074,
  lng: -0.1278,
};
